import * as types from 'containers/pages/addressManagement/constants';
import { AddressFormData } from 'containers/pages/addressManagement/types';

interface AddressAction {
  type: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  payload: any;
}

const addressFormReducer = (state: AddressFormData, action: AddressAction): AddressFormData => {
  switch (action.type) {
    case types.RESET:
    case types.ADDRESS_CONVERT:
      return action.payload;
    default:
      if (action.type in state) {
        return { ...state, [action.type]: action.payload };
      }
      return state;
  }
};

export default addressFormReducer;
